export default "__VITE_ASSET__BwjgXz_U__"